import "./MiamiHomeInspector.module.css";
import Header from "@/reusable_sections/Header";
import SellYourMotorcycleFastAndSafe from "./sections/SellYourMotorcycleFastAndSafe";
import LandlordsIntro from "./sections/LandlordsIntro";
import BurntStoreLocalExpertise from "./sections/BurntStoreLocalExpertise";
import LetsStartWithARealConversation from "./sections/LetsStartWithARealConversation";
import Footer from "@/reusable_sections/Footer";
export default function MiamiHomeInspectorPage() {
  return <div>
      <Header />
      <SellYourMotorcycleFastAndSafe />
      <LandlordsIntro />
      <BurntStoreLocalExpertise />
      <LetsStartWithARealConversation />
      <Footer />
    </div>;
}